export default "__VITE_ASSET__CbIlxx6a__"